import { NgModule } from '@angular/core';

import { MxBlockCopyPasteDirective } from './mx.block-copy-paste.directive';
import { MxEllipsisDirective } from './mx.ellipsis.directive';

export const DIRECTIVES: any[] = [MxBlockCopyPasteDirective, MxEllipsisDirective];

@NgModule({
  imports: [],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class MxDirectivesModule {}
